module.exports = __webpack_public_path__ + "img/roulette_btn.86597a9a.png";